var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetDatatableTabs',{attrs:{"items":_vm.data.data,"headersList":_vm.headers,"defaultTarget":"count","nbTabs":0,"comparable":false,"reverseChips":"","searchable":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.conf.title))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }